import { GridColDef } from '@mui/x-data-grid';
import { TStaffResponse } from '../../../../../apis/staff/staff.interfaces';
import { Edit, Delete } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { PermissionGate } from '../../../../../components/rbac/PermissionGate';

type TranslateFunction = (key: string) => string;

export const getStaffGridRowsToRender = (records: TStaffResponse[]) => {
  return records;
};

export const getColumnsForStaffGrid = (
  onRowClickHandler: (data: TStaffResponse) => void,
  translateText: TranslateFunction,
  onDeleteHandler?: (data: TStaffResponse) => void
): GridColDef[] => {
  return [
    {
      field: 'basicDetails.firstName',
      headerName: translateText('staff.list.columns.name'),
      width: 200,
      renderCell: (params) => {
        const data = params.row;
        return `${data.basicDetails.firstName}${data.basicDetails.middleName ? ' ' + data.basicDetails.middleName : ''} ${data.basicDetails.lastName}`;
      },
    },
    {
      field: 'designation',
      headerName: translateText('staff.list.columns.designation'),
      width: 150,
    },
    {
      field: 'department',
      headerName: translateText('staff.list.columns.department'),
      width: 150,
    },
    {
      field: 'email',
      headerName: translateText('staff.list.columns.email'),
      width: 220,
    },
    {
      field: 'employmentStatus',
      headerName: translateText('staff.list.columns.status'),
      width: 120,
    },
    {
      field: 'actions',
      headerName: translateText('staff.list.columns.actions'),
      width: 150,
      renderCell: (params) => {
        return (
          <Box data-testid="row-actions" sx={{ display: 'flex', gap: 0.5 }}>
            <IconButton
              onClick={() => onRowClickHandler(params.row)}
              color="primary"
              data-testid="row-edit-button"
              sx={{ minWidth: { xs: '44px', sm: '40px' }, minHeight: { xs: '44px', sm: '40px' } }}
            >
              <Edit color="primary" sx={{ fontSize: { xs: '1.25rem', sm: '1.2rem' } }} />
            </IconButton>
            {onDeleteHandler && (
              <PermissionGate module="staff" submodule="staffList" permission="delete">
                <IconButton
                  onClick={() => onDeleteHandler(params.row)}
                  color="error"
                  data-testid="row-delete-button"
                  sx={{ minWidth: { xs: '44px', sm: '40px' }, minHeight: { xs: '44px', sm: '40px' } }}
                >
                  <Delete sx={{ fontSize: { xs: '1.25rem', sm: '1.2rem' } }} />
                </IconButton>
              </PermissionGate>
            )}
          </Box>
        );
      },
    },
  ];
};
